import axios from "axios";

const {apiUrl} = window['runConfig'];

export const instance = axios.create({
    baseURL: apiUrl,
    headers: {
        "Content-Type": "application/json",
        "X-Warehouse": localStorage.getItem('warehouse') === null ? '' : localStorage.getItem('warehouse') !== 'All' ? localStorage.getItem('warehouse') : ''
    }
})


export const loginGoogle = (googleToken) => {
    return new Promise((resolve, reject) => {
        instance.post(`/auth`, {"token": googleToken}).then(resp => {
            const token = resp.data
            instance.get(`${apiUrl}/auth`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token.access_token}`,
                    }
                })
                .then(resp => {
                    return resolve(token)
                })
                .catch(error => {
                    return reject(error)
                })
        })
            .catch(error => {
                return reject(error)
            })
    })
}


export const loginEmail = (email) => {
    return new Promise((resolve, reject) => {
        instance.post(`${apiUrl}/auth`, {"email": email})
            .then(resp => {
                return resolve(resp.data)
            })
            .catch(error => {
                return reject(error)
            })
    })
}


export const loginToken = (token) => {
    return new Promise((resolve, reject) => {
        instance.put(`${apiUrl}/auth`, {"refresh_token": token})
            .then(resp => {
                return resolve(resp.data)
            })
            .catch(error => {
                return reject(error)
            })
    })
}


export const refreshToken = (token) => {
    return new Promise((resolve, reject) => {
        instance.post(`${apiUrl}/auth/refresh`, {refresh_token: token})
            .then(resp => {
                return resolve(resp.data)
            })
            .catch(error => {
                return reject(error)
            })
    })
}


export const getCurrentUser = (accessToken) => {
    return new Promise((resolve, reject) => {
        instance.get(`${apiUrl}/auth`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
            .then(resp => {
                return resolve(resp.data)
            })
            .catch(error => {
                return reject(error)
            })
    })
}


export const checkDefaultRole = (accessToken) => {
    return new Promise((resolve, reject) => {
        instance.get(`${apiUrl}/auth/test/role`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
            .then(resp => {
                return resolve(resp.data)
            })
            .catch(error => {
                return reject(error)
            })
    })
}


export const checkFakeRole = (accessToken) => {
    return new Promise((resolve, reject) => {
        instance.get(`${apiUrl}/auth/test/forbidden`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
            .then(resp => {
                return resolve(resp.data)
            })
            .catch(error => {
                return reject(error)
            })
    })
}


export const logout = (accessToken) => {
    return new Promise((resolve, reject) => {
        axios.delete(`/auth`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            })
            .then(resp => {
                return resolve(resp.data)
            })
            .catch(error => {
                return reject(error)
            })
    })
}
